import script from "./DigitalChecklistSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalChecklistSection.vue?vue&type=script&setup=true&lang=js"

import "./DigitalChecklistSection.vue?vue&type=style&index=0&id=897a709a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-897a709a"]])

export default __exports__